module.exports = __webpack_public_path__ + "static/img/yiduona_icon.e3675dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/yiduona_icon.png
// module id = GemQ
// module chunks = 1